import React from 'react';
import PropTypes from 'prop-types';

import styles from '../Search.scss';

function FormRow({ label, children }) {
    return (<div className={styles['form-row']}>
        <div className={styles['form-item-stacked']}>
            <div className={styles['form-label']}>
                <span className={styles['label-text']}>
                    {label}
                    :
                </span>
            </div>
            <div className={styles['form-field']}>
                {children}
            </div>
        </div>
    </div>)
}

FormRow.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default FormRow;
